export default "__VITE_ASSET__DbDKgYnH__"